import React from "react";
import { clearAllFilters, handleFilterChange, handleSearchChange, removeFilter } from "./Filter.js";

const FilterBar = ({ filters, setFilters, activeFilters , setActiveFilters }) => {
  return (
    <div className="top">
      <div className="filter-container">
        <input
          type="text"
          placeholder="Search by title..."
          value={filters.search}
          onChange={(e) => {
            handleSearchChange(
              e,
              filters,
              setFilters,
              setActiveFilters,
              activeFilters
            );
          }}
          className="search-bar"
        />
        <select
          name="status"
          value={filters.status}
          onChange={(e) => {
            handleFilterChange(e, filters, setFilters, setActiveFilters);
          }}
        >
          <option value="">All Statuses</option>
          <option value="Pending">Pending</option>
          <option value="Approved">Approved</option>
          <option value="Processing">Processing</option>
          <option value="Done">Done</option>
        </select>
        <select
          name="sort"
          value={filters.sort}
          onChange={(e) => {
            handleFilterChange(e, filters, setFilters, setActiveFilters);
          }}
        >
          <option value="">Default</option>
          <option value="amountLowToHigh">Amount: Low to High</option>
          <option value="amountHighToLow">Amount: High to Low</option>
        </select>
      </div>
      <div className="active-filters">
        {Object.keys(activeFilters).map(
          (key) =>
            activeFilters[key] && (
              <div key={key} className="filter-chip">
                <span>
                  {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                  {activeFilters[key]}
                </span>
                <button
                  onClick={() =>
                    removeFilter(key, filters, setFilters, setActiveFilters)
                  }
                >
                  X
                </button>
              </div>
            )
        )}
        {Object.values(activeFilters).some((filter) => filter) && (
          <button
            onClick={() => {
              clearAllFilters(setFilters, setActiveFilters);
            }}
            className="clear-all-button"
          >
            Clear All
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
